import { types } from "mobx-state-tree";

export const DEFAULT_MESSAGE = "Error";

export const Error = types.model({
  customMessage: types.optional(types.string, DEFAULT_MESSAGE),
  originalError: types.frozen(),
});
